<template>
  <div class="card">
    <Toast />
    <div class="title">Total Barang Masuk Bulanan</div>
    <div class="p-grid p-fluid p-mb-2">
      <div class="p-col">
        <Calendar
          v-model="start_date"
          :showIcon="true"
          dateFormat="yy-mm-dd"
          placeholder="Start Date"
          :selectOtherMonths="true"
          :showButtonBar="true"
        />
      </div>
      <div class="p-col">
        <Calendar
          v-model="end_date"
          :showIcon="true"
          dateFormat="yy-mm-dd"
          placeholder="End Date"
          :selectOtherMonths="true"
          :showButtonBar="true"
        />
      </div>
      <div class="p-col-4">
        <Button
          label="Cari"
          class="p-button-info"
          @click="getItemInbound()"
          v-shortkey.push="['enter']"
          @shortkey="getItemInbound()"
        />
      </div>

      <div class="p-col-12">
        <Toast />

        <div class="p-col">
          <div class="title">Total Item : {{ this.total_item | number }}</div>
        </div>
        <div class="p-col">
          <div class="title">Total Qty : {{ this.total_qty | number }}</div>
        </div>
        <div class="p-col">
          <div class="title">
            Total Harga (Rp) : {{ this.total_price | currency }}
          </div>
        </div>

        <div class="card">
          <DataTable
            :value="outlet_inbound"
            :paginator="true"
            class="p-datatable-outlets"
            :rows="10"
          >
            <template #empty>Data tidak tersedia.</template>
            <template #loading>Sedang mengambil data. Mohon tunggu.</template>
            <Column field="doc_number" header="Nomor Bon">
              <template #body="slotProps">
                {{ slotProps.data.doc_number }}
              </template>
            </Column>

            <Column field="doc_date" header="Tanggal Bon">
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.doc_date }}
                </span>
              </template>
            </Column>

            <Column header="Total Barang">
              <template #body="slotProps">
                <span>{{ slotProps.data.total_item | number }}</span>
              </template>
            </Column>

            <Column header="Total Qty">
              <template #body="slotProps">
                <span>{{ slotProps.data.total_qty | number }}</span>
              </template>
            </Column>

            <Column header="Total Harga">
              <template #body="slotProps">
                <span>{{ slotProps.data.total_price | currency }}</span>
              </template>
            </Column>

            <Column header="Status">
              <template #body="slotProps">
                <div v-if="slotProps.data.status == 1">
                  <span style="color: green; font-weight: bold">Confirmed</span>
                </div>
                <div v-else-if="slotProps.data.status == 2">
                  <span style="color: blue; font-weight: bold">Rejected</span>
                </div>
                <div v-else>
                  <span style="color: red; font-weight: bold">Pending</span>
                </div>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
var moment = require('moment')

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  watch: {
    user() {
      this.getAuthUser()
    }
  },
  data() {
    return {
      moment: moment,
      omset_date: null,
      outlet_inbound: null,
      total_price: null,
      today: new Date().toISOString().split('T')[0],
      start_date: null,
      end_date: null,
      total_qty: null,
      total_item: null,
      items: null
    }
  },
  mounted() {
    this.getAuthUser()
    this.getItemInbound()
  },
  methods: {
    getAuthUser() {
      console.info(this.user)
      this.start_date = this.today
      this.end_date = this.today
    },

    getItemInbound() {
      let start_date = this.start_date
        ? moment(this.start_date).format('YYYY-MM-DD')
        : this.today
      let end_date = this.end_date
        ? moment(this.end_date).format('YYYY-MM-DD')
        : this.today

      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbounds/range?start_date=${start_date}&end_date=${end_date}`
        )
        .then(response => {
          if (response.status === 200) {
            this.omset_date = response.data.data.outlet_inbounds.doc_date
            this.outlet_inbound = response.data.data.outlet_inbounds
            this.total_price = response.data.data.total_price
            this.total_item = response.data.data.total_item
            this.total_qty = response.data.data.total_qty
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
h5 {
  font-size: 16px;
}

::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
